import template from './claimDisplayBox.html';
import controller from './claimDisplayBox.controller';

let component = {
  restrict: 'E',
  template,
  controller,
  controllerAs: 'vm',
  bindings: {
    staffUser: '<',
    claim: '<',
  }
};

export default component;
